import Model from "../Model";

class ComercialsdetailGestnoGest extends Model{

    buildUrl ({ param }) {
        return ['allzonebyindustrialgroupview/getdimensionbyregion', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ComercialsdetailGestnoGest;